import * as T from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Button, Container } from './ui/pageElements';
import { HelpModal } from './ui/helpScreen';

export function getSceneColor() {
    return new T.Color(0x263238);
}

export function initScene(helpScreenData) {
    let scene, camera, renderer, controls;

    // scene
    scene = new T.Scene();
    scene.background = getSceneColor();

    camera = new T.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.001, 1000);
    camera.position.set(3, 3, 3);
    camera.lookAt(0, 0, 0);

    renderer = new T.WebGLRenderer({
        antialias: true,
        preserveDrawingBuffer: true
    });
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;
    document.body.appendChild(renderer.domElement);

    const directionalLight = new T.DirectionalLight(0xffffff, 1.0);
    directionalLight.castShadow = true;
    directionalLight.shadow.mapSize.setScalar(1024);
    directionalLight.position.set(5, 30, 15);
    scene.add(directionalLight);

    const ambientLight = new T.AmbientLight(0xffffff, 0.2);
    scene.add(ambientLight);

    const ground = new T.Mesh(new T.PlaneBufferGeometry(), new T.ShadowMaterial({ opacity: 0.25 }));
    ground.rotation.x = -Math.PI / 2;
    ground.scale.setScalar(30);
    ground.receiveShadow = true;
    scene.add(ground);

    controls = new OrbitControls(camera, renderer.domElement);
    controls.target.y = 1;
    controls.update();

    let uiControlDiv = document.createElement('div');
    uiControlDiv.id = "uiControlDiv";
    document.body.appendChild(uiControlDiv);

    let leftDiv = document.createElement('div');
    leftDiv.id = "leftDiv";
    document.body.appendChild(leftDiv);

    let rightDiv = document.createElement('div');
    rightDiv.id = "rightDiv";
    document.body.appendChild(rightDiv);

    let topDiv = document.createElement('div');
    topDiv.id = "topDiv";
    document.body.appendChild(topDiv);

    let bottomDiv = document.createElement('div');
    bottomDiv.id = "bottomDiv";
    document.body.appendChild(bottomDiv);

    let bottomLeftDiv = document.createElement('div');
    bottomLeftDiv.id = "bottomLeftDiv"
    document.body.appendChild(bottomLeftDiv)

    let bottomRightDiv = document.createElement('div');
    bottomRightDiv.id = "bottomRightDiv"
    document.body.appendChild(bottomRightDiv)

    let multiMotionDiv = document.createElement('div');
    multiMotionDiv.id = "multiMotionDiv";
    document.body.appendChild(multiMotionDiv);

    let leftContainer = new Container("leftContainer", "leftDiv", true);
    let rightContainer = new Container("rightContainer", "rightDiv", true);

    let robotListHeaderContainer = new Container("robotListHeaderContainer", "leftContainer", true);
    let robotListContainer = new Container("robotListContainer", "leftContainer", true);
    let lineListHeaderContainer = new Container("lineListHeaderContainer", "leftContainer", true);
    let lineListContainer = new Container("lineListContainer", "leftContainer", true);
    let jointListContainer = new Container("jointListContainer", "rightContainer", true);
    let cameraListHeaderContainer = new Container("cameraListHeaderContainer", "rightContainer", true);
    let cameraListContainer = new Container("cameraListContainer", "rightContainer", true);

    leftContainer.addBlock(robotListHeaderContainer, robotListContainer, lineListHeaderContainer, lineListContainer);
    rightContainer.addBlock(jointListContainer, cameraListHeaderContainer, cameraListContainer);

    let tabStates = {
        top: true,
        bottom: true,
        left: true,
        right: true
    }

    function toggleTop() {
        let div = document.getElementById("topDiv");
        let button = document.getElementById("Hide-Top-Tab-button")
        if (div) {
            button.innerHTML = "Show Top Tab";
            div.remove();
            tabStates.top = false;
        } else {
            document.body.appendChild(topDiv);
            button.innerHTML = "Hide Top Tab";
            tabStates.top = true;
        }
    }

    function toggleBottom() {
        let div = document.getElementById("bottomDiv");
        let button = document.getElementById("Hide-Bottom-Tab-button")
        if (div) {
            button.innerHTML = "Show Bottom Tab";
            div.remove();
            document.getElementById("multiMotionDiv").remove()
            tabStates.bottom = false;
        } else {
            document.body.appendChild(bottomDiv);
            document.body.appendChild(multiMotionDiv);
            button.innerHTML = "Hide Bottom Tab";
            tabStates.bottom = true;
        }
    }

    function toggleLeft() {
        let div = document.getElementById("leftDiv");
        let button = document.getElementById("Hide-Left-Tab-button")
        if (div) {
            button.innerHTML = "Show Left Tab";
            div.remove();
            tabStates.left = false;
        } else {
            document.body.appendChild(leftDiv);
            button.innerHTML = "Hide Left Tab";
            tabStates.left = true;
        }
    }

    function toggleRight() {
        let div = document.getElementById("rightDiv");
        let button = document.getElementById("Hide-Right-Tab-button")
        if (div) {
            button.innerHTML = "Show Right Tab";
            div.remove();
            tabStates.right = false;
        } else {
            document.body.appendChild(rightDiv);
            button.innerHTML = "Hide Right Tab";
            tabStates.right = true;
        }
    }

    let uiContainer = new Container("uiControlContainer", "uiControlDiv");
    let hideTopButton = new Button("Hide Top Tab", "uiControlContainer", toggleTop)
    let hideBottomButton = new Button("Hide Bottom Tab", "uiControlContainer", toggleBottom)
    let hideLeftButton = new Button("Hide Left Tab", "uiControlContainer", toggleLeft)
    let hideRightButton = new Button("Hide Right Tab", "uiControlContainer", toggleRight)

    let helpScreen = new HelpModal(helpScreenData);
    uiContainer.addBlock(hideLeftButton, hideBottomButton, hideTopButton, hideRightButton, helpScreen.getButton());

    function onResize() {
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(window.devicePixelRatio);
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
    }

    onResize();
    window.addEventListener('resize', onResize);

    return {
        scene: scene,
        camera: camera,
        renderer: renderer,
        controls: controls,
        tabSettings: {
            divs: {
                left: leftDiv,
                right: rightDiv,
                top: topDiv,
                bottom: bottomDiv
            },
            state: tabStates,
            controls: {
                top: toggleTop,
                bottom: toggleBottom,
                left: toggleLeft,
                right: toggleRight,
                removeUIControl: () => {
                    let div = document.getElementById("uiControlDiv");
                    div.remove();
                }
            }
        }
    };
}